import { AppstoreOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { Col, Row, Spin, message, Radio, Tooltip } from "antd";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { apiDeleteUiForm, apiGetUiForms } from "services/dashboardService";
import { showFormUiAddModal } from "./FormUI/showFormUiAddModal";
import FormUiTable from "./FormUI/FormUiTable";
import FormUiGroupedView from "./FormUI/FormUiGroupedView";

const Step1FormTab = (props) => {
  const { registrationID, setRegistrationID, settingInfo, registrationType } = props;
  const userDataStore = useSelector((x) => x.userDataStore);
  const appDataStore = useSelector((x) => x.appDataStore);

  const [dataList, setDataList] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isBusy, setIsBusy] = useState(false);
  const [viewMode, setViewMode] = useState("grouped"); // "grouped" or "table"

  useEffect(() => {
    if (registrationID) {
      loadData();
    }
  }, [registrationID, settingInfo?.registration_info?.registration_type]);

  // Get current registration type
  const currentRegType = registrationType || settingInfo?.registration_info?.registration_type || "individual";

  const onAdd = async (presetGroup = null) => {
    var resInfo = await showFormUiAddModal({
      title: "Add UI Element for Step1",
      token: userDataStore.token,
      columns: columns,
      registrationID: registrationID,
      presetGroup: presetGroup,
      registrationType: currentRegType,
    });
    if (resInfo == null) return;
    loadData();
  };

  const loadData = () => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("registration_id", registrationID);
    // Pass registration_type so backend returns correct columns
    params.append("registration_type", currentRegType);
    setIsBusy(true);
    apiGetUiForms(params)
      .then((res) => {
        setDataList(res.ui_list);
        setColumns(res.fields_list);
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const updateData = async (info) => {
    var resInfo = await showFormUiAddModal({
      title: "Update UI Element for Step1",
      token: userDataStore.token,
      registrationID: registrationID,
      columns: columns,
      info: info,
      registrationType: currentRegType,
    });
    if (resInfo == null) return;
    loadData();
  };

  const deleteData = (id) => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("id", id);
    setIsBusy(true);
    apiDeleteUiForm(params)
      .then((res) => {
        setIsBusy(false);
        loadData();
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const handleAddToGroup = (group) => {
    onAdd({
      group_title: group.title,
      group_type: group.groupType,
    });
  };

  return (
    <div>
      <Spin spinning={isBusy}>
        <Row
          gutter={[16, 16]}
          style={{ marginTop: 20 }}
          justify={"space-between"}
          align="middle"
        >
          <Col>
            <div style={{ fontWeight: 600, fontSize: 16 }}>
              Registration Form Fields
            </div>
            <div style={{ color: "#666", fontSize: 13, marginTop: 4 }}>
              Configure the fields that will appear on your registration form
            </div>
          </Col>
          <Col>
            <Row gutter={16} align="middle">
              <Col>
                <Radio.Group
                  value={viewMode}
                  onChange={(e) => setViewMode(e.target.value)}
                  optionType="button"
                  buttonStyle="solid"
                  size="small"
                >
                  <Tooltip title="Grouped View">
                    <Radio.Button value="grouped">
                      <AppstoreOutlined />
                    </Radio.Button>
                  </Tooltip>
                  <Tooltip title="Table View">
                    <Radio.Button value="table">
                      <UnorderedListOutlined />
                    </Radio.Button>
                  </Tooltip>
                </Radio.Group>
              </Col>
              <Col>
                <CommonButton
                  onClick={() => {
                    onAdd();
                  }}
                >
                  Add New Field
                </CommonButton>
              </Col>
            </Row>
          </Col>
        </Row>

        <div style={{ marginTop: 20 }}>
          {viewMode === "grouped" ? (
            <FormUiGroupedView
              dataList={dataList}
              deleteData={deleteData}
              updateData={updateData}
              onAddToGroup={handleAddToGroup}
              registrationType={currentRegType}
            />
          ) : (
            <FormUiTable
              dataList={dataList}
              deleteData={deleteData}
              updateData={updateData}
              registrationType={currentRegType}
            />
          )}
        </div>
      </Spin>
    </div>
  );
};

export default Step1FormTab;
